import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import { useTranslation } from 'react-i18next';

function UrunSearch({ setModel, value, searchParam, Product }) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const [search, setSearch] = React.useState('');
  const [fromBarkod, setFromBarkod] = React.useState(false);
  const { t } = useTranslation('overview');
  React.useEffect(() => {
    // let active = true;
    if (search.length > 4 && (open || fromBarkod)) {
      if (Product?.length > 0) {
        axios
          .get(`/GetProductSpecificSearch/${search.toString().toLocaleLowerCase(localStorage.i18nextLng_normalized)}/${Product}`)
          .then(res => {
            // if (active || fromBarkod) {
            const response = res.data;
            if (response.length > 0) {
              fromBarkod ? updateModel(response[0]) : setOptions(response);
            } else {
              fromBarkod
                ? updateModel({ ACIKLAMA: '', KUL_MODEL_KODU: '' })
                : setOptions([]);
            }
            // }
          })
          .catch(err => {
            if (fromBarkod) {
              updateModel({ ACIKLAMA: '', KUL_MODEL_KODU: search });
            }
            setOptions([]);
          });
      }
      else {
        axios
          .get(`/GetSiriusModels/${search.toString().toLocaleLowerCase(localStorage.i18nextLng_normalized)}`)
          .then(res => {
            // if (active || fromBarkod) {
            const response = res.data;
            if (response.length > 0) {
              fromBarkod ? updateModel(response[0]) : setOptions(response);
            } else {
              fromBarkod
                ? updateModel({ ACIKLAMA: '', KUL_MODEL_KODU: '' })
                : setOptions([]);
            }
            // }
          })
          .catch(err => {
            if (fromBarkod) {
              updateModel({ ACIKLAMA: '', KUL_MODEL_KODU: search });
            }
            setOptions([]);
          });
      }
    }
    // return () => {
    //     active = false;
    // };
    // eslint-disable-next-line
  }, [search, open, loading, fromBarkod]);

  React.useEffect(() => {
    if (searchParam.length > 0) {
      setFromBarkod(true);
      setSearch(searchParam);
    }
  }, [searchParam]);

  const updateModel = model => {
    setModel(model);
    value.ACIKLAMA = model.ACIKLAMA;
    value.KUL_MODEL_KODU = model.KUL_MODEL_KODU;
    setFromBarkod(false);
  };

  return (
    <Autocomplete
      id="asynchronous-demo"
      open={open}
      value={value}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      getOptionLabel={option => {
        return option.KUL_MODEL_KODU
          ? `${option.KUL_MODEL_KODU} - ${option.ACIKLAMA}`
          : '';
      }}
      options={options}
      filterOptions={(options, state) => options}
      loading={loading}
      onChange={(event, newValue) => {
        if (newValue && newValue.ACIKLAMA) {
          updateModel(newValue);
        }
        else {
          setModel({})
        }
      }}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          size="small"
          onChange={e => {
            setSearch(e.target.value);
          }}
          variant="outlined"
          label={t('lblProduct')}
          // helperText={value ? value.ACIKLAMA : ''}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
}

export default UrunSearch;
